import { getSportsnewBetErrorCode, getSportsnewBetErrorMessage } from './sportsnewBetErrorMessage.js';

export const SPORTSNEW_SELECTED_RECOVERY_CODES = new Set([
  'ODDS_CHANGED',
  'ODDS_STALE',
  'MARKET_UNAVAILABLE',
  'SELECTION_UNAVAILABLE',
  'SELECTION_MODE_MISMATCH',
]);

export const shouldResyncAfterBetError = (message = '') => {
  const raw = String(message || '');
  const text = raw.replace(/\s+/g, '').toLowerCase();
  if (!text) return false;

  const hasBettingSubject =
    text.includes('배당')
    || text.includes('마켓')
    || text.includes('경기')
    || text.includes('선택')
    || /odd|market|selection|fixture|match/.test(text);

  const hasChangedState =
    text.includes('변경')
    || text.includes('변동')
    || text.includes('마감')
    || text.includes('잠김')
    || text.includes('잠겼')
    || text.includes('중지')
    || text.includes('종료')
    || text.includes('최신')
    || text.includes('닫')
    || /chang|clos|suspend|lock|unavailable|expired|stale/.test(text);

  return hasBettingSubject && hasChangedState;
};

const isLegacySelectedRecoveryMessage = (message = '') => {
  const text = String(message || '').replace(/\s+/g, ' ').trim();
  if (!text) return false;
  if (/ODDS_(?:CHANGED|STALE)|MARKET_UNAVAILABLE|SELECTION_(?:UNAVAILABLE|MODE_MISMATCH)/i.test(text)) {
    return true;
  }
  return /배당.*(?:변경|변동|지연|최신|잠김|잠겼|잠겨|이용.*불가|이용할 수 없|더 이상 이용)/.test(text)
    || /(?:마켓|선택(?:지)?).*(?:변경|닫|잠김|잠겼|잠겨|이용.*불가|이용할 수 없|더 이상 이용)/.test(text)
    || /경기\s*구분.*변경/.test(text);
};

export const shouldRecoverSportsnewSelectedOdds = (source) => {
  const structuredCode = getSportsnewBetErrorCode(source);
  if (structuredCode) return SPORTSNEW_SELECTED_RECOVERY_CODES.has(structuredCode);
  const legacyMessage = getSportsnewBetErrorMessage(source, '')
    || source?.void_reason
    || source?.voidReason
    || source?.message;
  return isLegacySelectedRecoveryMessage(legacyMessage);
};

export const recoverAfterSportsnewBetError = async ({
  source,
  submittedSelections,
  displayScope,
  recoverSelectedOddsForCart,
  forceResyncOdds,
}) => {
  if (shouldRecoverSportsnewSelectedOdds(source)) {
    if (typeof recoverSelectedOddsForCart === 'function') {
      await recoverSelectedOddsForCart(submittedSelections, displayScope);
    }
    return { path: 'sportsnew_selected' };
  }

  const message = getSportsnewBetErrorMessage(source, '')
    || source?.void_reason
    || source?.voidReason
    || source?.message;
  if (shouldResyncAfterBetError(message) && typeof forceResyncOdds === 'function') {
    await forceResyncOdds(submittedSelections);
    return { path: 'legacy_force' };
  }
  return { path: 'none' };
};

export const recoverAfterSportsnewBonusConfirmError = ({
  bonusRecoveryRequest,
  fallbackSelections,
  ...recovery
}) => recoverAfterSportsnewBetError({
  ...recovery,
  submittedSelections: Array.isArray(bonusRecoveryRequest?.submittedSelections)
    ? bonusRecoveryRequest.submittedSelections
    : fallbackSelections,
});
